import { barProps as H } from "./index787.js";
import { defineComponent as W, inject as w, ref as a, openBlock as b, createElementBlock as S, Fragment as _, createVNode as x } from "vue";
import { GAP as l } from "./index670.js";
import z from "./index788.js";
import { scrollbarContextKey as $ } from "./index673.js";
var Y = /* @__PURE__ */ W({
  __name: "bar",
  props: H,
  setup(n, { expose: y }) {
    const u = n, v = w($), h = a(0), d = a(0), p = a(""), g = a(""), r = a(1), c = a(1);
    return y({
      handleScroll: (e) => {
        if (e) {
          const t = e.offsetHeight - l, o = e.offsetWidth - l;
          d.value = e.scrollTop * 100 / t * r.value, h.value = e.scrollLeft * 100 / o * c.value;
        }
      },
      update: () => {
        const e = v?.wrapElement;
        if (!e) return;
        const t = e.offsetHeight - l, o = e.offsetWidth - l, f = t ** 2 / e.scrollHeight, m = o ** 2 / e.scrollWidth, s = Math.max(f, u.minSize), i = Math.max(m, u.minSize);
        r.value = f / (t - f) / (s / (t - s)), c.value = m / (o - m) / (i / (o - i)), g.value = s + l < t ? `${s}px` : "", p.value = i + l < o ? `${i}px` : "";
      }
    }), (e, t) => (b(), S(
      _,
      null,
      [
        x(z, {
          move: h.value,
          ratio: c.value,
          size: p.value,
          always: n.always
        }, null, 8, ["move", "ratio", "size", "always"]),
        x(z, {
          move: d.value,
          ratio: r.value,
          size: g.value,
          vertical: "",
          always: n.always
        }, null, 8, ["move", "ratio", "size", "always"])
      ],
      64
      /* STABLE_FRAGMENT */
    ));
  }
});
export {
  Y as default
};
